export default "__VITE_ASSET__CAsCglPD__"